/** The one gate. Password in, cookie out, good for a year. */

import { api, ApiError } from "../api.ts";
import { el, mount, primaryButton, shell } from "../ui.ts";

export function renderLogin(onSuccess: () => void): void {
	const input = el("input", {
		class: "field",
		type: "password",
		autocomplete: "current-password",
		"aria-label": "Password",
		placeholder: "Password",
	});
	const status = el("div", { class: "stack--tight", "aria-live": "polite" });

	const submit = async (): Promise<void> => {
		const password = input.value;
		if (password === "") return;
		button.disabled = true;
		button.textContent = "Checking…";
		try {
			await api.login(password);
			onSuccess();
		} catch (error) {
			status.replaceChildren(
				el("div", {
					class: "notice notice--brick",
					text: error instanceof ApiError ? error.message : "That did not work. Try again.",
				}),
			);
			button.disabled = false;
			button.textContent = "Enter";
			input.value = "";
			input.focus();
		}
	};

	const button = primaryButton("Enter", () => {
		void submit();
	});

	input.addEventListener("keydown", (event) => {
		if ((event as KeyboardEvent).key === "Enter") void submit();
	});

	mount(
		shell({
			eyebrowLeft: "Fala",
			body: [
				el("h1", { class: "display", style: "margin-top:40px", lang: "pt-BR", text: "Bem-vindo" }),
				el("p", { class: "en", style: "margin-top:8px", text: "Brazilian Portuguese, ten minutes a day." }),
				el("div", { class: "stack" }, input),
				status,
			],
			footer: button,
		}),
	);

	input.focus();
}
